export var ITEMS = [{
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001521-47ac.png',
  hoverImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001538-6524.png',
  title: '电商',
  link: 'https://www.gaoding.com/templates/f4799078,4799098',
  titleColor: '#EC5534',
  linkObjs: [{
    text: '电商海报',
    url: 'https://www.gaoding.com/templates/f4799078,4799527'
  }, {
    text: '电商主图',
    url: 'https://www.gaoding.com/templates/f4799078,4799531'
  }, {
    text: '详情页',
    url: 'https://www.gaoding.com/templates/f4799078,4799534'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001637-97e1.png',
  hoverImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001654-ac7b.png',
  link: 'https://www.gaoding.com/templates/f4799078,4799956',
  title: '新媒体',
  titleColor: '#45A03D',
  linkObjs: [{
    text: '长图海报',
    url: 'https://www.gaoding.com/templates/fc4800010-f4799078,4799510'
  }, {
    text: '公众号首图',
    url: 'https://www.gaoding.com/templates/f4799078,4799512'
  }, {
    text: '广告banner',
    url: 'https://www.gaoding.com/templates/f4799078,4799542'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001707-b6d4.png',
  title: '教育培训',
  hoverImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-101216-58a8.png',
  link: 'https://www.gaoding.com/templates/f4799078,4799109',
  titleColor: '#E28800',
  linkObjs: [{
    text: '招生海报',
    url: 'https://www.gaoding.com/templates/f4799078,4799510,4799109'
  }, {
    text: '课程封面',
    url: 'https://www.gaoding.com/templates/f4799078,4799542,4799109'
  }, {
    text: '公众号次图',
    url: 'https://www.gaoding.com/templates/f4799078,4799513'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001742-3433.png',
  hoverImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-001759-30c8.png',
  title: '海量素材',
  link: 'https://www.gaoding.com/templates/f4799078',
  titleColor: '#663EDA',
  linkObjs: [{
    text: '小红书配图',
    url: 'https://www.gaoding.com/templates/f4799078,4799535'
  }, {
    text: '视频封面',
    url: 'https://www.gaoding.com/templates/f4799078,4799532'
  }, {
    text: 'GIF动图',
    url: 'https://www.gaoding.com/templates/d472?q=gif'
  }]
}];